import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SegundaParte.module.css';

import IconMaintenance from '../../../../utils/images/ssc_mantenimiento_v2.svg';
import IconScada from '../../../../utils/images/ssc_scada_v2.svg';
import IconAdministrative from '../../../../utils/images/ssc_administrativa_v2.svg';
import IconControl from '../../../../utils/images/ssc_inventario_v2.svg';
import IconResources from '../../../../utils/images/ssc_recursos_v2.svg';
import IconEnergy from '../../../../utils/images/ssc_energia_v2.svg';
// Si querés mostrar también "position", agregá su ícono:
// import IconPosition from '../../../../utils/images/posicionamiento-icon.png';

const items = [
  {
    img: IconMaintenance,
    titleKey: 'Products.sscEnterprise.SecondPart.maintenance.title',
    descKey: 'Products.sscEnterprise.SecondPart.maintenance.description',
  },
  {
    img: IconScada,
    titleKey: 'Products.sscEnterprise.SecondPart.scada.title',
    descKey: 'Products.sscEnterprise.SecondPart.scada.description',
  },
  {
    img: IconAdministrative,
    titleKey: 'Products.sscEnterprise.SecondPart.administrative.title',
    descKey: 'Products.sscEnterprise.SecondPart.administrative.description',
  },
  {
    img: IconControl,
    titleKey: 'Products.sscEnterprise.SecondPart.control.title',
    descKey: 'Products.sscEnterprise.SecondPart.control.description',
  },
  {
    img: IconResources,
    titleKey: 'Products.sscEnterprise.SecondPart.resources.title',
    descKey: 'Products.sscEnterprise.SecondPart.resources.description',
  },
  {
    img: IconEnergy,
    titleKey: 'Products.sscEnterprise.SecondPart.energy.title',
    descKey: 'Products.sscEnterprise.SecondPart.energy.description',
  },
  // Opcional: incluir position si tenés ícono y querés mostrarlo
  // {
  //   img: IconPosition,
  //   titleKey: 'Products.sscEnterprise.SecondPart.position.title',
  //   descKey: 'Products.sscEnterprise.SecondPart.position.description',
  // },
];

const SegundaParte = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.wrapper}>
      <h2 className={styles.title}>
        {t('Products.sscEnterprise.SecondPart.title')}
      </h2>

      <div className={styles.grid}>
        {items.map((item, index) => (
          <div key={index} className={styles.item}>
            <div className={styles.iconBox}>
              <img src={item.img} alt="" className={styles.image} />
            </div>

            <p className={styles.itemTitle}>{t(item.titleKey)}</p>
            <p className={styles.itemText}>{t(item.descKey)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SegundaParte;
